import classNames from 'classnames';
import { formatMeetingReminderLabel } from '@/modules/common/helpers/meetingReminders.ts';
import { MeetingReminder } from 'compliance-api';

interface MeetingRemindersSummaryProps {
  reminders: MeetingReminder[];
  withBottomBorder?: boolean;
}

export const MeetingRemindersSummary = ({
  reminders,
  withBottomBorder = true,
}: MeetingRemindersSummaryProps) => {
  return (
    <div className={classNames('flex flex-col gap-4 py-8 px-6', withBottomBorder && 'border-b')}>
      <div className="flex items-center gap-2">
        <span className="text-sm leading-[22px] text-gray-900 font-medium">Meeting reminders</span>
        <span className="text-sm leading-[22px] text-gray-500 font-medium">{reminders.length}</span>
      </div>

      {!reminders.length && <div className="text-sm text-gray-500">No reminders set.</div>}

      {!!reminders.length && (
        <div className="flex flex-col gap-1">
          {reminders.map((reminder, index) => (
            <div
              key={`${reminder.value}-${reminder.unit}-${index}`}
              className="text-sm text-gray-900"
            >
              {formatMeetingReminderLabel(reminder)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
